/**
 * client/src/services/backgroundGeoPlugin.ts
 *
 * Istanza UNICA del plugin nativo @capacitor-community/background-geolocation.
 *
 * PERCHÉ QUESTO FILE (7 Ott 2026): il pacchetto su npm pubblica SOLO i tipi
 * (definitions.d.ts) e nessun entry point JS — il suo package.json non è
 * risolvibile dai bundler. Qualsiasi `import` del pacchetto, anche per i soli
 * tipi, rompe la build Vite ("Failed to resolve entry for package"). Qui il
 * plugin viene istanziato UNA volta con registerPlugin e condiviso dai
 * consumer (backgroundGeoBridge, pluginHealthCheck).
 *
 * Il nome "BackgroundGeolocation" deve combaciare con
 * @CapacitorPlugin(name = "BackgroundGeolocation") dichiarato in
 * BackgroundGeolocation.java del plugin stesso.
 */

import { registerPlugin } from "@capacitor/core";

export interface BgGeoWatcherOptions {
  backgroundMessage?: string;
  backgroundTitle?: string;
  requestPermissions?: boolean;
  stale?: boolean;
  distanceFilter?: number;
}

export interface BgGeoLocation {
  latitude: number;
  longitude: number;
  accuracy: number;
  altitude?: number | null;
  speed?: number | null;
  bearing?: number | null;
  time?: number;
}

export interface BgGeoError {
  code?: string | number;
  message?: string;
}

export interface BgGeoPlugin {
  addWatcher(
    options: BgGeoWatcherOptions,
    callback: (position?: BgGeoLocation, error?: BgGeoError) => void,
  ): Promise<string>;
  removeWatcher(options: { id: string }): Promise<void>;
  openSettings(): Promise<void>;
}

/** Nome nativo del plugin (deve combaciare con @CapacitorPlugin lato Android/iOS). */
export const BACKGROUND_GEO_PLUGIN_NAME = "BackgroundGeolocation";

export const BackgroundGeolocation =
  registerPlugin<BgGeoPlugin>(BACKGROUND_GEO_PLUGIN_NAME);
